import {defineComponent, onMounted, reactive, ref} from "vue";
import DistanceItem from "./DistanceItem";

export default defineComponent({
    name: "Distance",
    props: {
        tableData: {},
        update: null
    },
    setup(props) {

        const width_max = ref(0)
        const height_max = ref(0)

        const position = reactive({
            distance_x: 20,//横向间隔距离
            distance_y: 40,//纵向间隔距离
            width: 120,//宽度
            height: [],//每一行的高度
            boxGrid: [],//建立九宫格视图
            max_x: 0,
            max_y: 0,

            header_w: 24,//圆的宽
            header_y: 24,//圆的高
        })

        const data = reactive({
            data: [],
            lineList: [],
            drawLineList: [],
            groupList: []
        })

        /**
         * 处理数据
         * @param data
         * @returns {*[]}
         */
        const dataProcessing = (data) => {
            let x = []
            let y = []
            let list = data.list
            list.forEach(v => {
                x.push(v.position[1])
                y.push(v.position[0])
            })
            position.max_x = Math.max(...x)
            position.max_y = Math.max(...y)

            position.height = []
            for (let i = 0; i < position.max_y; i++) {
                position.height.push(0)
            }

            list.forEach(v => {
                if (v.content.content.length >= position.height[v.position[0] - 1]) {
                    position.height[v.position[0] - 1] = (v.content.content.length + (v.content.link ? 1 : 0))
                }
            })
            return list
        }

        /**
         * 这个建立九宫格视图，并不是九个
         */
        const boxGridView = () => {
            let list = []
            let after = 0
            for (let i = 0; i < position.max_y; i++) {
                let row = []
                for (let j = 0; j < position.max_x; j++) {
                    let x = position.distance_x * (j + 1) + position.width * j
                    let y = position.distance_y * (i + 1) + after
                    row.push([x, y])
                }
                after += (71 + 20 * position.height[i])
                list.push(row)
            }
            width_max.value = (position.distance_x + position.width) * position.max_x + position.distance_x * 2
            height_max.value = list[list.length - 1][0][1] + (71 + 20 * position.height[position.height.length - 1]) + 20
            position.boxGrid = list
        }

        /**
         * 通过九宫格建立视图
         * @param list
         */
        const generatedData = (list) => {
            list.forEach(v => {
                let row = v.position[0] - 1
                let col = v.position[1] - 1
                v.placeholder = position.boxGrid[row][col]
            })
        }
        /**
         * 将数据映射到九宫格上
         * @param list
         * @returns {*[]}
         */
        const renderView = (list) => {
            let array = []

            list.map((v, i) => {
                let header = {}
                let content = {}
                let link = {}
                if (Object.prototype.toString.call(v.content.title) === "[object String]") {
                    header.title = v.content.title
                } else {
                    header = v.content.title
                }
                content.list = v.content.content
                if (Object.prototype.toString.call(v.content.link) === "[object Object]") {
                    link = v.content.link
                }
                let left = v.placeholder[0] + "px"
                let top = v.placeholder[1] + "px"
                array.push(<DistanceItem header={header} content={content} link={link} style={`left:${left};top:${top}`} status={v.status} index={i}/>)
            })
            return array
        }

        /**
         * 创建线
         * @param list
         */
        const createLine = (list) => {
            let ic = 1
            let offset_x_start = 74
            let offset_x_end = 46
            let offset_y_start = 10
            let offset_y_end = 10
            let removeItemList = []
            let lineList = list.map(v => {
                //标记一条线
                let obj = {id: ic.toString(), status: v.status, nextNode: v.next, beforeNode: v.id}
                if (removeItemList.includes(v.id)) return
                //先寻找相同级别的路径
                let nextList = list.filter(vl => v.next && vl.next === v.next)

                if (nextList.length > 1) {
                    //多对一关系
                    let array = []
                    for (let i = 0; i < nextList.length; i++) {
                        //计算线的开始坐标
                        let item = nextList[i]
                        obj.id = ic.toString()
                        obj.nextNode = item.next
                        obj.beforeNode = item.id
                        obj.start = [item.placeholder[0] + offset_x_start, item.placeholder[1] + offset_y_start]
                        //计算线的结束位置
                        let next = list.filter(vn => vn.id === item.next)[0]
                        obj.end = [next.placeholder[0] + offset_x_end, next.placeholder[1] + offset_y_end]
                        obj.type = "many-for-one"
                        if (!removeItemList.includes(item.id)) {
                            removeItemList.push(item.id)
                        }
                        array.push(JSON.parse(JSON.stringify(obj)))
                        ic++
                    }
                    return array
                } else {
                    //计算线的开始坐标
                    obj.start = [v.placeholder[0] + offset_x_start, v.placeholder[1] + offset_y_start]

                    //计算结束位置
                    if (v.next) {
                        if (Object.prototype.toString.call(v.next) === "[object String]") {
                            //计算线的结束位置，一个后置节点
                            let next = list.filter(vn => vn.id === v.next)[0]
                            obj.end = [next.placeholder[0] + offset_x_end, next.placeholder[1] + offset_y_end]
                            ic++
                            return obj
                        } else {
                            //计算线的结束位置，多个后置节点
                            let acc = []
                            for (let i = 0; i < v.next.length; i++) {
                                let next = list.filter(vn => vn.id === v.next[i])[0]
                                obj.id = ic.toString()
                                obj.nextNode = next.id
                                obj.end = [next.placeholder[0] + offset_x_end, next.placeholder[1] + offset_y_end]
                                obj.type = "one-to-many"
                                acc.push(JSON.parse(JSON.stringify(obj)))
                                ic++
                            }
                            return acc
                        }
                    }
                }
            }).filter(v => v)

            //以下的数据都是偏移好了的
            let padding = 20
            let line_w = 4
            let one_half = 46//一个item去除半个圆
            let rLineList = [] //流程对应的线
            let virtual_line_list = []//要画的线
            let id = 1

            //不能展开，开始对数据处理
            for (const value of lineList) {
                // 寻址，数组
                if (Object.prototype.toString.call(value) === "[object Array]") {
                    //如果是个数组
                    if (value[0].type === "many-for-one") {
                        //多对一,倒序寻址
                        // vertical 竖
                        // horizontal 横

                        value.forEach(v => {
                            let id_list = []//暂时的存线的

                            let old_end = v.end //结束点
                            let old_start = v.start //开始点

                            let virtual_broken_line_list = ["start", "start_start", "end_end", "end"]//折线组合列表

                            let virtual_obj = {
                                start: [old_start[0], old_start[1]],//这里是折线第一个点
                                start_start: [(old_end[0] - one_half - (padding / 2 + line_w / 2)), old_start[1]],//这是第二个节点
                                end_end: [old_end[0] - one_half - (padding / 2 + line_w / 2), old_end[1]],//这里是折线前一个拐点
                                end: [old_end[0], old_end[1]]//这里是折线最后一个点
                            }

                            //这里的逻辑很繁杂--20230914 01：09：08 以后别问我写的啥，因为我也不知道，看不懂了。
                            for (let i = 0; i < virtual_broken_line_list.length; i++) {
                                if (virtual_broken_line_list[i] !== "end") {
                                    let start = virtual_obj[virtual_broken_line_list[i]]
                                    let end = virtual_obj[virtual_broken_line_list[i + 1]]
                                    //不存在相同的线，生成线，并添加进线的描述列表
                                    if (!virtual_line_list.some(v => (JSON.stringify(v.start) === JSON.stringify(start) && JSON.stringify(v.end) === JSON.stringify(end)))) {
                                        if (JSON.stringify(start) !== JSON.stringify(end)) {
                                            let rObj = {
                                                id: id,
                                                start: start,
                                                end: end,
                                            }
                                            if (virtual_broken_line_list[i] === "end_end") {
                                                rObj.arrow = true
                                            }
                                            if (end[0] - start[0] !== 0 && end[1] - start[1] === 0) {
                                                let p = []
                                                if (end[0] - start[0] > 0) {
                                                    p = start
                                                } else {
                                                    p = end
                                                }
                                                virtual_line_list.push({
                                                    ...rObj,
                                                    position: p,
                                                    type: "horizontal",
                                                    length: Math.abs(end[0] - start[0])
                                                })
                                            }
                                            if (end[1] - start[1] !== 0 && end[0] - start[0] === 0) {
                                                let p = []
                                                if (end[1] - start[1] > 0) {
                                                    p = start
                                                } else {
                                                    p = end
                                                }
                                                virtual_line_list.push({
                                                    ...rObj,
                                                    position: p,
                                                    type: "vertical",
                                                    length: Math.abs(end[1] - start[1]) + 4
                                                })
                                            }
                                            id_list.push(id)
                                            id++
                                        }
                                    } else {
                                        //存在相同的线，不处理线
                                        let row = virtual_line_list.filter(vc => JSON.stringify(vc.start) === JSON.stringify(start) && JSON.stringify(vc.end) === JSON.stringify(end))[0]
                                        id_list.push(row.id)
                                    }
                                }
                            }
                            rLineList.push({id: v.beforeNode + "-" + v.nextNode, line: id_list})
                        })
                    } else {
                        // 一对多,正序寻址
                        // vertical 竖
                        // horizontal 横

                        value.forEach(v => {
                            let id_list = []//暂时的存线的

                            let old_end = v.end //结束点
                            let old_start = v.start //开始点

                            let virtual_broken_line_list = ["start", "start_start", "end_end", "end"]//折线组合列表

                            let virtual_obj = {
                                start: [old_start[0], old_start[1]],//这里是折线第一个点
                                start_start: [(old_start[0] + one_half + (padding - line_w) / 2), old_start[1]],//这是第二个节点
                                end_end: [(old_start[0] + one_half + (padding - line_w) / 2), old_end[1]],//这里是折线前一个拐点
                                end: [old_end[0], old_end[1]]//这里是折线最后一个点
                            }

                            //这里的逻辑很繁杂--20230914 01：09：08 以后别问我写的啥，因为我也不知道，看不懂了。
                            for (let i = 0; i < virtual_broken_line_list.length; i++) {
                                if (virtual_broken_line_list[i] !== "end") {
                                    let start = virtual_obj[virtual_broken_line_list[i]]
                                    let end = virtual_obj[virtual_broken_line_list[i + 1]]
                                    //不存在相同的线，生成线，并添加进线的描述列表
                                    if (!virtual_line_list.some(v => (JSON.stringify(v.start) === JSON.stringify(start) && JSON.stringify(v.end) === JSON.stringify(end)))) {
                                        if (JSON.stringify(start) !== JSON.stringify(end)) {
                                            let rObj = {
                                                id: id,
                                                start: start,
                                                end: end
                                            }
                                            if (virtual_broken_line_list[i] === "end_end") {
                                                rObj.arrow = true
                                            }
                                            if (end[0] - start[0] !== 0 && end[1] - start[1] === 0) {
                                                let p = []
                                                if (end[0] - start[0] > 0) {
                                                    p = start
                                                } else {
                                                    p = end
                                                }
                                                virtual_line_list.push({
                                                    ...rObj,
                                                    position: p,
                                                    type: "horizontal",
                                                    length: Math.abs(end[0] - start[0])
                                                })
                                            }
                                            if (end[1] - start[1] !== 0 && end[0] - start[0] === 0) {
                                                let p = []
                                                if (end[1] - start[1] > 0) {
                                                    p = start
                                                } else {
                                                    p = end
                                                }
                                                virtual_line_list.push({
                                                    ...rObj,
                                                    position: p,
                                                    type: "vertical",
                                                    length: Math.abs(end[1] - start[1]) + 4
                                                })
                                            }
                                            id_list.push(id)
                                            id++
                                        }
                                    } else {
                                        //存在相同的线，不处理线
                                        let row = virtual_line_list.filter(vc => JSON.stringify(vc.start) === JSON.stringify(start) && JSON.stringify(vc.end) === JSON.stringify(end))[0]
                                        id_list.push(row.id)
                                    }
                                    id++
                                }
                            }
                            rLineList.push({id: v.beforeNode + "-" + v.nextNode, line: id_list})
                        })
                    }
                } else {
                    //一对一的关系，不存在多入多出的情况
                    let start = value.start
                    let end = value.end
                    if (end[0] - start[0] !== 0 && end[1] - start[1] === 0) {
                        let p = []
                        if (end[0] - start[0] > 0) {
                            p = start
                        } else {
                            p = end
                        }
                        virtual_line_list.push({id: id, arrow: true, position: p, start: start, end: end, type: "horizontal", length: Math.abs(end[0] - start[0]) - 2})
                    }
                    if (end[1] - start[1] !== 0 && end[0] - start[0] === 0) {
                        let p = []
                        if (end[1] - start[1] > 0) {
                            p = start
                        } else {
                            p = end
                        }
                        virtual_line_list.push({id: id, position: p, start: start, end: end, type: "vertical", length: Math.abs(end[1] - start[1])})
                    }
                    rLineList.push({id: value.beforeNode + "-" + value.nextNode, line: id})
                    id++
                }
            }

            //灵魂洗涤，开始和结束节点删除
            data.lineList = rLineList.map(v => {
                let o = data.data.filter(value => value.id === v.id.split("-")[1])[0]
                return {
                    id: o.id,
                    line: v.line,
                    status: o.status
                }
            })
            //要开始画线了
            //划线前对线进行偏移处理

            data.drawLineList = virtual_line_list
        }

        /**
         * 画线算法
         * @param list
         * @returns {*[]}
         */
        const drawLine = (list) => {
            let arr = []
            let line12Status = 'default'
            let line7Status = 'default'
            let line6Style = ""
            list.forEach(config => {
                let list = []
                if (Object.prototype.toString.call(config.line) === "[object Array]") {
                    config.line.filter(v => {
                        let obj = data.drawLineList.filter(value => v === value.id)[0]
                        list.push({...obj, status: config.status})
                    })
                } else {
                    let obj = data.drawLineList.filter(value => config.line === value.id)[0]
                    list.push({...obj, status: config.status})
                }
                list.forEach(v => {
                    let style = v.type === "vertical" ? `height:${v.length}px;` : `width:${v.length}px;`
                    style += `left:${v.position[0]}px;top:${v.position[1]}px`
                    // 原装代码
                    // arr.push(<div className={"be-current-vertical"} status={v.status} type={v.type} style={style} arrow={v.arrow}/>)

                    // 流程图 线段补丁
                    if(v.id == 12){
                      // 型号经理收样后的半线段
                      if(v.status == "success"){
                        line12Status = "success"
                      }else if(v.status == "warning" && line12Status != 'success' ){
                        line12Status = "warning"
                      }
                    }
                    // if(v.id == 7){
                    //   // 型号经理审核后的线段 7 /8 
                    //   if(v.status == "warning"){
                    //     line7Status = "warning"
                    //   }else if(v.status == "default" && line12Status != 'warning'){
                    //     line7Status = "default"
                    //   }
                    // }
                    if(v.id == 6){
                      // 物料结论后的半线段
                      line6Style = style
                    }
                    if(v.id == 12){
                      arr.push(<div id={'line'+v.id} className={"be-current-vertical"} status={v.id == 12 ? line12Status : v.status} type={v.type} style={style} arrow={v.arrow}/>)
                    }else if(v.id == 7){
                      arr.push(<div id={'line'+v.id} className={"be-current-vertical"} status={v.id == 7 ? line7Status : v.status} type={v.type} style={style} arrow={v.arrow}/>)
                    }else if(v.id == 8){
                      arr.push(<div id={'line'+v.id} className={"be-current-vertical"} status={v.id == 8 ? line7Status : v.status} type={v.type} style={style} arrow={v.arrow}/>)
                    }else if(v.id == 29 && v.status == 'default'){
                      // 改物料结论左半边线
                      arr.push(<div id={'line6'} className={"be-current-vertical"} status={'default'} type={v.type} style={line6Style} arrow={false}/>)
                      arr.push(<div id={'line'+v.id} className={"be-current-vertical"} status={v.status} type={v.type} style={style} arrow={v.arrow}/>)
                    }else {
                      arr.push(<div id={'line'+v.id} className={"be-current-vertical"} status={v.status} type={v.type} style={style} arrow={v.arrow}/>)
                    }
                })
            })
            return arr
        }

        const groupData = (config) => {

            let dataList = data.data
            let list = config.group
            let width_skew = 129//宽度偏移相加
            let height_skew = 35//高度偏移相加
            let x_skew = 5//x偏移相减
            let y_skew = 30//y偏移相减

            list.forEach((value, index) => {
                value.groupList = value.group.map(v => {
                    for (let i = 0; i < dataList.length; i++) {
                        if (parseInt(dataList[i]["id"]) === parseInt(v)) {
                            return dataList[i]["placeholder"][0]
                        }
                    }
                })
                let start = dataList.filter(v => v["id"] === Math.min(...value.group.map(c => parseInt(c))).toString())[0]["placeholder"]
                value.start = [start[0] - x_skew, start[1] - y_skew]
                value.height = 71 + position.height[index] * 20 + height_skew
                value.length = Math.max(...value.groupList) - Math.min(...value.groupList) + width_skew
            })
            return list
        }

        const drawGroup = (list) => {
            let arr = []
            list.forEach(v => {
                let style = `width:${v.length}px;height:${v.height}px;left:${v.start[0]}px;top:${v.start[1]}px`
                let dom = <div className={"distance-canvas-group"} style={style}>
                    <div className={"distance-canvas-group-header"} style={`background:${v.color}`}>
                        <div className={"group-header-title"}>{v.title}</div>
                    </div>
                    <div className={"distance-canvas-group-content"} style={`height:${v.height - 28}px;border-color:${v.color}`}></div>
                </div>
                arr.push(dom)
            })
            return arr
        }

        const updateView = (config) => {
            data.data = dataProcessing(config)
            boxGridView()
            generatedData(data.data)
            createLine(data.data)
            data.groupList = groupData(config)
        }

        const view = (w, h) => {
            return <div className={'distance-canvas'} style={`width:${w}px;height:${h}px`}>
                {renderView(data.data)}
                {drawLine(data.lineList)}
                {drawGroup(data.groupList)}
            </div>

        }


        const init = () => {
            data.data = dataProcessing(props.tableData)
            boxGridView()
            generatedData(data.data)
            createLine(data.data)
            data.groupList = groupData(props.tableData)
            props.update(updateView)
        }

        onMounted(() => {
            init()
        })


        return () => view(width_max.value, height_max.value)
    }
})
